import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightMemoPayment from "./RightMemoPayment";
import MemoPaymentMain from "./MemoPaymentMain";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";


const MemoPayment = (props) => {
  const location = useLocation();
  const [payment, setPayment] = useState({})
  const [payMethod, setPayMethod] = useState(0);

  useEffect(() => {
    setPayment(location.state.payment);
  }, [location]);

  const onChangePayMethod = (id) =>{
    setPayMethod(id);
  }

  return (
    <React.Fragment>
      <Container fluid className="vendor-orders-request">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container fluid>
              <Row>
                <Col md={8}>
                  <MemoPaymentMain payment={payment} onChangePayMethod={onChangePayMethod} />
                </Col>
                <Col md={4}>
                  <RightMemoPayment payment={true} data={payment} payMethod={payMethod} />
                </Col>
              </Row>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </Container>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(MemoPayment);
